import { LEGAL_DOCUMENT_TYPES, TLegalDocumentType } from "@/api/legal";

export const DOCUMENT_TYPE_OPTIONS: { value: TLegalDocumentType; label: string; filterLabel: string }[] = [
  { value: LEGAL_DOCUMENT_TYPES.termsOfService, label: "Terms of Service", filterLabel: "Terms" },
  { value: LEGAL_DOCUMENT_TYPES.privacyPolicy, label: "Privacy Policy", filterLabel: "Privacy" },
  { value: LEGAL_DOCUMENT_TYPES.cookiesPolicy, label: "Cookies Policy", filterLabel: "Cookies" },
];

export const DOCUMENT_TYPE_LABELS: Record<TLegalDocumentType, string> = {
  [LEGAL_DOCUMENT_TYPES.termsOfService]: "Terms of Service",
  [LEGAL_DOCUMENT_TYPES.privacyPolicy]: "Privacy Policy",
  [LEGAL_DOCUMENT_TYPES.cookiesPolicy]: "Cookies Policy",
};

export function formatEffectiveDate(value: string): string {
  return new Date(value).toLocaleDateString();
}

export function toDateInputValue(value: string): string {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  return date.toISOString().slice(0, 10);
}

export function dateInputToIso(dateValue: string): string {
  const date = new Date(`${dateValue}T00:00:00`);
  return date.toISOString();
}
